export async function downloadGuidesUseCase(guide_ids, guideRepostitory) {
    const result = await guideRepostitory.donwload_guides(guide_ids);

    return result;
}